export interface UploadFileOutput {
	fileType?: string; //type of file in regard to business context (e.g. Rhythmedix CSV, Cloudbeat CSV, etc.)
	files: FileList;
}
